import { render, staticRenderFns } from "./CategoryMerge.vue?vue&type=template&id=d26d7880&scoped=true&"
import script from "./CategoryMerge.vue?vue&type=script&lang=js&"
export * from "./CategoryMerge.vue?vue&type=script&lang=js&"
import style0 from "./CategoryMerge.vue?vue&type=style&index=0&id=d26d7880&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d26d7880",
  null
  
)

export default component.exports